// MM: there is just no way I could remove the import cycle due to the way localsync has to be created
// with defined argument that I can't tweak to pass them dispatch via curry or such

/* ----------------------------- */
/*   Actions for the auth
/* ----------------------------- */

// axios instance whose headers should be updated when the token is updated
import { axiosInstance } from 'AppSrc/core/queries/axios-queries';
import {
  getV1Authcheck,
  getSAMLAuthenticate,
} from 'AppSrc/core/auth/auth-queries';
import {
  decodeJWTPayload,
  makeUserFromJWTPayload,
} from 'AppSrc/core/auth/auth-functions';
import { isTokenSavedInSyncedStorageSelector } from 'AppSrc/core/auth/auth-selectors';
import { setJWTTokenInLocalSyncController } from 'AppSrc/core/store/middleware/redux-local-synch-controller-actions';
import {
  TOKEN_CHECKING,
  TOKEN_VALID,
  TOKEN_INVALID,
  SET_TOKEN,
  CLEAR_TOKEN,
  SET_USER,
  CLEAR_USER,
  SET_SAML_AUTH_URL_FETCHING,
  SET_SAML_AUTH_URL,
  SET_AUTHENTICATING,
  SAML_AUTH_ERROR,
  SET_TOKEN_AND_USER,
  CLEAR_TOKEN_AND_USER,
  TOKEN_SAVED_SYNCED_STORAGE,
  TOKEN_CLEARED_SYNCED_STORAGE,
  DELETE_ME_EVENTUALLY_CHANGE_USER_ROLE,
  DELETE_ME_EVENTUALLY_CHANGE_REMEDY_ID,
} from 'AppSrc/core/auth/auth-action-strings';
import { setOutageBanner } from 'AppSrc/core/components/outage-banner/outage-action';


/* ------ ACTION CREATORS ------ */

/* - synced Storage Synchronous actions - */

/* flag when the token is saved and cleared in syncedStorage */
const tokenSavedSyncedStorage = () => ({
  type: TOKEN_SAVED_SYNCED_STORAGE,
  payload: {
  },
});

const tokenClearedSyncedStorage = () => ({
  type: TOKEN_CLEARED_SYNCED_STORAGE,
  payload: {
  },
});


/* - Token Synchronous actions - */

/* Flag token validity is being checked (for a token in localStorage) */
const tokenChecking = () => ({
  type: TOKEN_CHECKING,
  payload: {
  },
});

/* Flag the token has been checked valid (for a token in localStorage) */
const tokenValid = () => ({
  type: TOKEN_VALID,
  payload: {
  },
});

/* Flag the token has been detected invalid but do not clear it until the refresh request has completed */
const tokenInvalid = () => ({
  type: TOKEN_INVALID,
  payload: {
  },
});

/* Init or update the token and its expiry date */
const setToken = (token, tokenExpiryDate) => ({
  type: SET_TOKEN,
  payload: {
    token,
    tokenExpiryDate,
  },
});


/* Clear the token and header after they have been found invalid */
const clearToken = () => ({
  type: CLEAR_TOKEN,
  payload: {
  },
});


/* - user Synchronous actions - */

const setUser = (user) => ({
  type: SET_USER,
  payload: {
    user,
  },
});

const clearUser = () => ({
  type: CLEAR_USER,
  payload: {
  },
});


/* - SAML AUTH Synchronous actions - */

/* Flag we are fetching the 3rd party SAML auth url  (SAML auth Step 1) */
const setSAMLAuthUrlFetching = () => ({
  type: SET_SAML_AUTH_URL_FETCHING,
  payload: {
  },
});


/* Init SAML third party url */
const setSAMLAuthUrl = (authUrl) => ({
  type: SET_SAML_AUTH_URL,
  payload: {
    authUrl,
  },
});

/* Flag SAML auth failed */
const SAMLAuthError = (error) => ({
  type: SAML_AUTH_ERROR,
  payload: {
    error,
  },
});

/* Flag SAML auth proper is in progress (SAML auth Step 2)
that is the user has clicked on the SAMLAuthUrl link and has been taken to third party authentication */
const setAuthenticating = () => ({
  type: SET_AUTHENTICATING,
  payload: {
  },
});

/* Init or update the token, token expiry date and user data at once */
const setTokenAndUser = (token, tokenExpiryDate, user, changeAnalyst) => ({
  type: SET_TOKEN_AND_USER,
  payload: {
    token,
    tokenExpiryDate,
    user,
    changeAnalyst,
  },
});

/* Clear the token, token expiry date and user data at once */
const clearTokenAndUser = () => ({
  type: CLEAR_TOKEN_AND_USER,
  payload: {
  },
});


// Tempory Actions For Testing
const deleteMeEventuallyChangeUserRole = (network, newRole) => ({
  type: DELETE_ME_EVENTUALLY_CHANGE_USER_ROLE,
  payload: {
    network,
    newRole,
  },
});

// Tempory Actions For Testing
const deleteMeEventuallyChangeRemedyId = (network, remedyId) => ({
  type: DELETE_ME_EVENTUALLY_CHANGE_REMEDY_ID,
  payload: {
    network,
    remedyId,
  },
});





/* - Thunk action: SAMLAuthenticate  - */
// relayState: The URL the user was trying to access (they will be forwarded on to this url after they have authed with SAML).
const SAMLAuthenticate = (relayState) => (dispatch, getState) => {

  console.log('SAMLAuthenticate GET SAML URL !!! relayState ', relayState);

  // notify reducer auth is in progress
  dispatch(setSAMLAuthUrlFetching());

  // REST get request
  return getSAMLAuthenticate(relayState)
    .then((response) => {
      // console.log('SAMLAuthenticate RESPONSE: ', response);
      dispatch(setSAMLAuthUrl(response));
    })
    .catch((error) => {
      // console.log('SAMLAuthenticate ERROR: ', error);
      dispatch(SAMLAuthError(error));
    });
};


/* --- Use Local and Session Storage to sync login accross tabs and on reload  --- */
/* - !!! weird mix of thunk actioms and events working together !!!  - */


/* - Thunk action: set Authorization from JWT token  - */
const setAuthorizationFromJWTToken = (JWTToken) => (dispatch, getState) => {
  // update the header inside the existing axios instance with raw JWT Token
  // https://github.com/axios/axios#custom-instance-defaults
  if (!axiosInstance.defaults.headers.common.Authorization) {
    console.log('Setting first JWTToken');
    axiosInstance.defaults.headers.common.Authorization = JWTToken;
    // Setting Outage Banner when user login first time
    dispatch(setOutageBanner(true));
  }

  // decode JWTPayload from JWTToken gibberish string
  const JWTPayload = decodeJWTPayload(JWTToken);
  // get token expiry date and user data from decoded JWTPayload
  const user = makeUserFromJWTPayload(JWTPayload);
  const tokenExpiryDate = JWTPayload.exp;
  // to extract the change analyst flag from JWT payload
  const changeAnalyst = JWTPayload.changeAnalyst_flag;

  // save the raw token, token expiry date and user data in redux
  dispatch(setTokenAndUser(JWTToken, tokenExpiryDate, user, changeAnalyst));

  // save the token in synced storage only if newly acquired token
  // do not save again a valid token retrieved from synced storage!!
  const tokenSavedInSyncedStorage = isTokenSavedInSyncedStorageSelector(getState());
  if (!tokenSavedInSyncedStorage) {
    dispatch(setJWTTokenInLocalSyncController(JWTToken));
    dispatch(tokenSavedSyncedStorage());
  }
};


/* - Thunk action: Logout  - */
const logout = () => (dispatch, getState) => {

  console.log('LOGOUT !!!');

  // delete the authorization header that has the old JWT Token inside the existing axios instance
  // otherwise it does the request for the SAML url with the old token, which causes a server error
  // https://github.com/axios/axios#custom-instance-defaults
  delete axiosInstance.defaults.headers.common.Authorization;

  // clear the raw token, token expiry date and user data in redux
  dispatch(clearTokenAndUser());

  // delete the saved token from synced storage
  dispatch(setJWTTokenInLocalSyncController(null));
  dispatch(tokenClearedSyncedStorage());
};


/* - Thunk action: checkTokenValid  - */
// // check wether a token on the request header is valid by making getV1Authcheck request with no data
const checkTokenValid = (JWTToken) => (dispatch, getState) => {

  // update the header inside the existing axios instance with raw JWT Token
  // https://github.com/axios/axios#custom-instance-defaults
  axiosInstance.defaults.headers.common.Authorization = JWTToken;

  // notify reducer token is checking
  dispatch(tokenChecking());

  // check wether the token on the request header is valid by making getV1Authcheck request with no data
  return getV1Authcheck()
    .then((response) => {
      console.log('checkTokenValid RESPONSE: ', response);

      dispatch(tokenValid());
      // MM: this is the case where a valid token is already in synced storage from another tab or a previous session
      // and completing the auth in this tab should not save it again !!!
      dispatch(tokenSavedSyncedStorage());
      dispatch(setAuthorizationFromJWTToken(JWTToken));
    })
    .catch((error) => {
      console.log('checkTokenValid ERROR: ', error);

      // we don't need to clear anything as the checked token from local storage was not in redux
      dispatch(tokenInvalid());

      // delete the authorization header that has the old JWT Token inside the existing axios instance
      // otherwise it does the request for the SAML url with the old token, which causes a server error
      // https://github.com/axios/axios#custom-instance-defaults
      delete axiosInstance.defaults.headers.common.Authorization;

      // delete the saved token from syncedStorageManager
      // the sync storage library detects itself whether the token is in permanent store or synced session store
      // syncedStorageManager.deleteData('token');
      dispatch(setJWTTokenInLocalSyncController(null));
      dispatch(tokenClearedSyncedStorage());

      // MM: DO NOT GET the SAML AUTH URL here !!
      // LET the LOGIN SCREN DO IT AS IT KNOWS WHICH ROUTE IT WAS REDIRECTED FROM !!
    });
};


export {
  setToken,
  clearToken,
  tokenChecking,
  tokenValid,
  tokenInvalid,
  checkTokenValid,
  setUser,
  clearUser,
  setTokenAndUser,
  clearTokenAndUser,
  setSAMLAuthUrlFetching,
  setSAMLAuthUrl,
  setAuthenticating,
  SAMLAuthError,
  SAMLAuthenticate,
  setAuthorizationFromJWTToken,
  logout,
  tokenSavedSyncedStorage,
  tokenClearedSyncedStorage,
  deleteMeEventuallyChangeUserRole,
  deleteMeEventuallyChangeRemedyId,
};


